module.exports = __webpack_public_path__ + "static/img/game-logo-bti.7fe22d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-bti.png
// module id = zxKr
// module chunks = 0 1 2 3 4 5 6